<template>
  <div class="w-full h-full flex items-center justify-center">
    <form class="w-full max-w-sm bg-gray-200 rounded shadow-md py-4 px-2" @submit.prevent="submit">
      <div class="w-full text-center text-6xl">💰</div>

      <b-input v-model="data.email" type="email" id="email" label="Email" :errors="form.errors"></b-input>

      <b-input v-model="data.password" type="password" id="password" label="Password" :errors="form.errors"></b-input>

      <div class="text-center mt-4">
        <b-button native-type="submit">Login</b-button>
      </div>
    </form>
  </div>
</template>

<script>
  import Form from 'form-backend-validation'
  import {EventBus} from "../events"

  export default {
    name: "Login",
    data() {
      return {
        form: new Form,
        data: {
          email: '',
          password: ''
        }
      }
    },
    methods: {
      async submit() {
        EventBus.$emit('loading:start');
        await this.$auth.login({
          data: {
            email: this.data.email,
            password: this.data.password
          },
          redirect: '/',
          success: () => {
            EventBus.$emit('loading:end');
          },
          error: (data) => {
            if (data.response && data.response.status === 422) {
              // this.$noty.warning("There was an issue with your request. Please review your input.")
              this.form.onFail(data);
              EventBus.$emit('loading:end')
            }
          },
          rememberMe: true,
          fetchUser: true
        });
      }
    }
  }
</script>
